import { createContext, useContext } from "react";

export const OpsCtx = createContext(null);
export const useOps = () => useContext(OpsCtx);

export const fmt = (d) => (d ? new Date(d).toLocaleString(undefined, { dateStyle: "short", timeStyle: "medium" }) : "—");

export function Panel({ title, children, actions, testid, className = "" }) {
  return (
    <section data-testid={testid} className={`border border-[#243144] bg-[#131a26] rounded ${className}`}>
      {(title || actions) && (
        <header className="flex items-center justify-between gap-3 border-b border-[#243144] px-3 py-2">
          <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-300">{title}</h2>
          <div className="flex items-center gap-2">{actions}</div>
        </header>
      )}
      <div className="p-3">{children}</div>
    </section>
  );
}

export function Btn({ children, variant = "default", className = "", ...p }) {
  const v = {
    default: "bg-sky-500/90 hover:bg-sky-400 text-slate-950",
    ghost: "bg-[#1a2332] hover:bg-[#223047] text-slate-200 border border-[#243144]",
    danger: "bg-red-500/90 hover:bg-red-400 text-white",
  }[variant];
  return <button type="button" className={`rounded px-2.5 py-1.5 text-xs font-medium transition-colors disabled:opacity-40 ${v} ${className}`} {...p}>{children}</button>;
}

export const inputCls = "w-full rounded border border-[#243144] bg-[#1a2332] px-2 py-1.5 text-sm text-slate-100 outline-none focus:border-sky-500";

export function StatusPill({ s }) {
  const c = { sent: "text-green-400", test_delivered: "text-green-400", received: "text-sky-400", scheduled: "text-amber-400",
    suppressed: "text-slate-400", failed: "text-red-400", waiting: "text-amber-400", running: "text-sky-400", done: "text-green-400" }[s] || "text-slate-400";
  return <span className={`mono text-[10px] uppercase ${c}`}>{s}</span>;
}
